/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Card, CardBody, CardHeader, UncontrolledTooltip } from 'reactstrap';
import { Link } from "react-router-dom";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from 'axios';
import SweetAlert from "react-bootstrap-sweetalert";

export default function TerminalParameter(props) {
  const token = localStorage.token;
  const terminalPk = props.terminalPk;
  const [terminalParameter, setTerminalParameter] = useState([]);
  const redirectPrefix = `/admin/terminal/parameter/${terminalPk}/edit/`;
  const [alert, setAlert] = React.useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [rowIndex, setRowIndex] = useState(0);
  const allowedRoles = ["ROLE_SUPERADMIN"]

  let paginationOption = {
    page: 1,
    alwaysShowAllBtns: true,
    override: true,
    showTotal: true,
    withFirstAndLast: false,
    onPageChange: (page) => {
      calculateRowIndex(page, currentPageSize);
    },
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
                setCurrentPageSize(e.target.value);
                calculateRowIndex(currentPage, e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          }{" "}
      entries.
    </label>
      </div>
    ),
  }

  const calculateRowIndex = (currentPage, currentPageSize) => {
    setRowIndex((currentPage - 1) * currentPageSize);
  }

  useEffect(() => {
    getAllTerminalParameter();
  }, [props.terminalPk]);

  const getAllTerminalParameter = () => {
    const data = { page: 1, per_page: 100, terminal_pk: terminalPk, };
    fetch(`${process.env.REACT_APP_API_BASE_URL}/params`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setTerminalParameter(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const delateParams = (terminal_param_id) => {
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/param/delete/${terminal_param_id}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        setSuccessAlert();
        getAllTerminalParameter();
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const setSuccessAlert = () => {
    setAlert(
      <SweetAlert
        success
        showConfirm
        confirmBtnText="Ok"
        title="Terminal Params deleted"
        onCancel={hideAlert}
        onConfirm={hideAlert}
      />
    )
  }

  const setQuestionAlert = (terminal_param_id) => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => delateParams(terminal_param_id)}
        onCancel={hideAlert}
        focusCancelBtn
      />
    )
  }

  const hideAlert = () => {
    setAlert(null);
  }

  return (
    <>
      {alert}
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>List Terminal</h3>
            {
              allowedRoles.includes(localStorage.getItem("authority"))
                ?
                <div style={{ textAlign: "right" }}>
                  <Link class="btn btn-info" to={`/admin/terminal/parameter/${terminalPk}/create`}>
                    Add
              </Link>
                </div>
                :
                <div></div>
            }
          </div>
        </CardHeader>
        <CardBody>
          {
            allowedRoles.includes(localStorage.getItem("authority"))
              ?
              <ToolkitProvider
                rowNumber={rowIndex}
                data={terminalParameter}
                keyField="terminal_param_id"
                columns={[
                  {
                    dataField: "no",
                    text: "#",
                    sort: true,
                    page: 1,
                    formatter: (cell, row, index) => {
                      let currentRow = ++index;
                      return currentRow + rowIndex;
                    }
                  },
                  {
                    dataField: "acquirer_name",
                    text: "Acquirer",
                    sort: true
                  },
                  {
                    dataField: "acquirer_host_type",
                    text: "Host Type",
                    sort: true
                  },
                  {
                    dataField: "tid",
                    text: "TID",
                    sort: true
                  },
                  {
                    dataField: "mid",
                    text: "MID",
                    sort: true
                  },
                  {
                    dataField: "stan",
                    text: "STAN",
                    sort: true
                  },
                  {
                    dataField: "batch_no",
                    text: "Batch No",
                    sort: true
                  },
                  {
                    dataField: "inv_no",
                    text: "INV No",
                    sort: true
                  },
                  {
                    dataField: "status",
                    text: "Status",
                    sort: true,
                    formatter: (cell, row) => {
                      return row.status === 1 ? "Active" : "InActive"
                    }
                  },
                  {
                    dataField: "", text: "", formatter: (cell, row, index) => {
                      return (
                        <ButtonGroup>
                          <Button>
                            <Link
                              to={redirectPrefix + row.terminal_param_id}
                              id={"tooltip_" + row.terminal_param_id}
                            >
                              <i className="fas fa-user-edit" />
                            </Link>
                          </Button>
                          <UncontrolledTooltip delay={0} target={"tooltip_" + row.terminal_param_id}>
                            Edit
                            </UncontrolledTooltip>
                          <Button
                            id="btn-acquirer"
                            onClick={() => setQuestionAlert(row.terminal_param_id)}
                          >
                            <i className="fas fa-trash" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            placement="top"
                            target="btn-acquirer"
                          >
                            Delete terminal param
                            </UncontrolledTooltip>
                        </ButtonGroup>
                      )
                    }
                  },
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      pagination={paginationFactory({ ...paginationOption })}
                    />
                  </div>
                )}
              </ToolkitProvider>
              :
              <ToolkitProvider
                rowNumber={rowIndex}
                data={terminalParameter}
                keyField="terminal_param_id"
                columns={[
                  {
                    dataField: "no",
                    text: "#",
                    sort: true,
                    page: 1,
                    formatter: (cell, row, index) => {
                      let currentRow = ++index;
                      return currentRow + rowIndex;
                    }
                  },
                  {
                    dataField: "acquirer_host_type",
                    text: "Host Type",
                    sort: true
                  },
                  {
                    dataField: "tid",
                    text: "TID",
                    sort: true
                  },
                  {
                    dataField: "mid",
                    text: "MID",
                    sort: true
                  },
                  {
                    dataField: "stan",
                    text: "STAN",
                    sort: true
                  },
                  {
                    dataField: "batch_no",
                    text: "Batch No",
                    sort: true
                  },
                  {
                    dataField: "inv_no",
                    text: "INV No",
                    sort: true
                  },
                  {
                    dataField: "status",
                    text: "Status",
                    sort: true,
                    formatter: (cell, row) => {
                      return row.status === 1 ? "Active" : "InActive"
                    }
                  },
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      pagination={paginationFactory({ ...paginationOption })}
                    />
                  </div>
                )}
              </ToolkitProvider>
          }
        </CardBody>
      </Card>
    </>
  );
}
